import P from '../pages';
import PropTypes from 'prop-types';
import FormHeader from './FormHeader';
import { defaultMessages } from '../../../libs/i18n/default';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import { CustomFormGroup, Form, FormDate } from '../../../shared/components';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { pageValid, fieldsToValidate } from '../../../shared/validator';
import { guestProfileSubmit } from '../actions';
import withDefaults from './withDefaults'
import { changeState, formatDate, optionsFromArray } from '../../../shared/utilities';
import { generateProfileElementObject } from '../../../shared/profileElementHelpers';

const Education = ({ content, dispatch, page, user, territory, environment, intl: { formatMessage } }) => {
  const thisPage = P.EDUCATION_PAGE;
  const [submitted, setSubmitted] = useState(false)
  const ieltsScoreSelections = useSelector(state => state.localProfileElements.elements.education.ielts_score_selections)
  const gradeSelections = useSelector(state => state.localProfileElements.elements.education.grade_selections)
  const [fields, setFields] = useState({
    course: generateProfileElementObject('', 'education', 'course'),
    providerRef: generateProfileElementObject('', 'education', 'provider_ref'),
    courseStartOn: generateProfileElementObject('', 'education', 'course_start_on'),
    courseEndOn: generateProfileElementObject('', 'education', 'course_end_on'),
    orientationStartOn: generateProfileElementObject('', 'education', 'orientation_start_on'),
    grade: generateProfileElementObject('', 'education', 'grade'),
    ieltsScore: generateProfileElementObject('', 'education', 'ielts_score'),
    course: generateProfileElementObject('', 'education', 'course'),
  })
  const fieldsRef = useRef(fields)
  fieldsRef.current = fields

  useEffect(() => {
    fieldsToValidate(fields).forEach(f => {
      handleChange(f, fields[f].val, false)
    })
  }, [])

  const handleChange = (key, val, resetDependentObject = true) => {
    changeState(
      fieldsRef.current,
      key,
      val,
      (newObj) => {
        setFields(prevFields => ({...prevFields, ...newObj}))
      },
      resetDependentObject
    )
  }

  const submit = (e) => {
    e.preventDefault()
    setSubmitted(true)
    dispatch(guestProfileSubmit({
      education: {
        course: fields.course.val,
        provider_ref: fields.providerRef.val,
        course_start_on: formatDate(fields.courseStartOn.val),
        course_end_on: formatDate(fields.courseEndOn.val),
        orientation_start_on: formatDate(fields.orientationStartOn.val),
        grade: fields.grade.val,
        ielts_score: fields.ieltsScore.val
      }
    }, thisPage))
  }

  return (
    <Form page={page} thisPage={thisPage} back={true} skip={environment != 'production'} submitFunc={submit} disableSubmit={!pageValid(fields) || submitted} >
      <FormHeader title={content.pages.education.title} />

      <CustomFormGroup field={fields.grade}>
        <ControlLabel htmlFor="grade">{formatMessage(defaultMessages.clientGuestPagesEducationLabelsGrade)}</ControlLabel>
        <FormControl id="grade"
          type="select"
          componentClass="select"
          defaultValue={fields.grade.val}
          onChange={e => handleChange(e.target.id, e.target.value)}>
          {optionsFromArray(gradeSelections, formatMessage)}
        </FormControl>
      </CustomFormGroup>

      <CustomFormGroup field={fields.course}>
        <ControlLabel htmlFor="course">{formatMessage(defaultMessages.clientGuestPagesEducationLabelsCourse)}</ControlLabel>
        <FormControl id="course"
          type="text"
          componentClass="input"
          defaultValue={fields.course.val}
          onChange={e => handleChange(e.target.id, e.target.value)} />
      </CustomFormGroup>

      <CustomFormGroup field={fields.providerRef}>
        <ControlLabel htmlFor="providerRef">{formatMessage(defaultMessages.clientGuestPagesEducationLabelsStudentId)}</ControlLabel>
        <FormControl id="providerRef"
          type="text"
          componentClass="input"
          defaultValue={fields.providerRef.val}
          onChange={e => handleChange(e.target.id, e.target.value)} />
      </CustomFormGroup>

      <CustomFormGroup field={fields.courseStartOn}>
        <ControlLabel htmlFor="courseStartOn_day">{content.pages.education.course_start}</ControlLabel>
        <FormDate
          setDate={date => handleChange('courseStartOn', date)}
          formDateId={'courseStartOn'}
          date={formatDate(fields.courseStartOn.val)} />
      </CustomFormGroup>

      <CustomFormGroup field={fields.courseEndOn}>
        <ControlLabel htmlFor="courseEndOn_day">{content.pages.education.course_end}</ControlLabel>
        <FormDate
          setDate={date => handleChange('courseEndOn', date)}
          formDateId={'courseEndOn'}
          date={formatDate(fields.courseEndOn.val)} />
      </CustomFormGroup>

      <CustomFormGroup field={fields.orientationStartOn}>
        <ControlLabel htmlFor="orientationStartOn_day">{formatMessage(defaultMessages.clientGuestPagesEducationLabelsOrientationStartOn)}</ControlLabel>
        <FormDate
          setDate={date => handleChange('orientationStartOn', date)}
          formDateId={'orientationStartOn'}
          date={formatDate(fields.orientationStartOn.val)} />
      </CustomFormGroup>

      <CustomFormGroup field={fields.ieltsScore}>
        <ControlLabel htmlFor="ieltsScore">{formatMessage(defaultMessages.clientGuestPagesEducationLabelsIelts)}</ControlLabel>
        <FormControl id="ieltsScore"
          type="select"
          componentClass="select"
          defaultValue={fields.ieltsScore.val}
          onChange={e => handleChange(e.target.id, e.target.value)}>
          {optionsFromArray(ieltsScoreSelections, formatMessage)}
        </FormControl>
      </CustomFormGroup>
    </Form>
  )
}

Education.propTypes = {
   onGuestProfileSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default withDefaults(Education);
